/**
 * str 를 받아 snake_case 를 camelCase 로 변환
 * e.g program_id => programId
 * @param str
 * @returns {*}
 */
export const snakeToCamel = (str) => {
  if (!str) {
    return undefined
  }

  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase())
}

/**
 * str 를 받아 템플릿 리터럴 안 snake_case 를 camelCase 로 변환
 * e.g `content_id__${program_id}` => `content_id__${programId}`
 * @param str
 * @returns {*}
 */
export const snakeToCamelTemplateLiterals = (str) => {
  return str.replace(/\${(.*?)}/g, (match, letter) => {
    return match.replace(letter, snakeToCamel(letter))
  })
}
